import { parsePerformanceTime } from "./formatTime";

export const byStartTime = (
  a: { startTime: string; dayId?: string },
  b: { startTime: string; dayId?: string },
) => {
  return (
    parsePerformanceTime(a.startTime, a.dayId).getTime() -
    parsePerformanceTime(b.startTime, b.dayId).getTime()
  );
};
